import * as React from "react"
import type { SVGProps } from "react"
const SvgButton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 8.14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a1 1 0 1 1-2 0v-3H5v8h5a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2z" />
    <path d="M12.03 12.68a1 1 0 0 0 0 .4l.62 2.06q.7 2.27 1.36 4.55c.17.58 1.01.6 1.2.01l.58-1.8 1.13 1.13 1.82 1.83a1 1 0 0 0 1.4-.01l.57-.57a1 1 0 0 0 .01-1.39A121 121 0 0 0 17.8 16l1.86-.65c.57-.2.54-1.01-.03-1.18a334 334 0 0 1-6.7-2 1 1 0 0 0-.4.02 1 1 0 0 0-.31.18 1 1 0 0 0-.19.32Z" />
  </svg>
)
export default SvgButton
